import type { Lang } from "./i18n.js";

/**
 * The home page's search/social copy, per language — the ONE place it lives.
 * Read at runtime by LandingPage (through useSeo) and at build time by
 * scripts/head-variants.ts, which stamps the English values into dist/en.html
 * so a crawler that never runs JavaScript still gets the right document on /en.
 * index.html carries the Turkish values statically; the build asserts they
 * match this file, so the two cannot drift apart.
 */
export interface HomeSeo {
  /** Full <title>, brand suffix included. */
  title: string;
  /** Open Graph / Twitter card title — the same without the brand suffix. */
  shortTitle: string;
  description: string;
  path: "/" | "/en";
  ogLocale: "tr_TR" | "en_GB";
  /** BCP 47 tag for JSON-LD inLanguage. */
  inLanguage: "tr-TR" | "en-GB";
  rssPath: "/blog/rss.xml" | "/en/blog/rss.xml";
}

export const HOME_SEO: Record<Lang, HomeSeo> = {
  tr: {
    title: "Dijital Ürün Pasaportu (DPP) Yazılımı — ESPR Uyumlu | IDPP.net",
    shortTitle: "Dijital Ürün Pasaportu (DPP) Yazılımı — ESPR Uyumlu",
    description:
      "AB'ye ihracat yapan üreticiler için ESPR ve EN 1821x uyumlu Dijital Ürün Pasaportu platformu. Ürün verisini bir kez girin, QR ile açılan imzalı pasaportta yayımlayın.",
    path: "/",
    ogLocale: "tr_TR",
    inLanguage: "tr-TR",
    rssPath: "/blog/rss.xml",
  },
  en: {
    title: "Digital Product Passport (DPP) Software — ESPR Compliant | IDPP.net",
    shortTitle: "Digital Product Passport (DPP) Software — ESPR Compliant",
    description:
      "ESPR- and EN 1821x-aligned Digital Product Passport platform for manufacturers exporting to the EU. Enter product data once, publish it on a signed passport behind a QR code.",
    path: "/en",
    ogLocale: "en_GB",
    inLanguage: "en-GB",
    rssPath: "/en/blog/rss.xml",
  },
};
